/**
 * Chat notification utilities
 */

/**
 * Play a sound notification for new chat messages
 */
export function playMessageNotification(): void {
  // Simple notification sound using Web Audio API
  try {
    const audioContext = new (
      window.AudioContext || (window as any).webkitAudioContext
    )();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.frequency.value = 800;
    oscillator.type = "sine";

    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(
      0.01,
      audioContext.currentTime + 0.5,
    );

    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.5);
  } catch (error) {
    // Silently fail if audio context not available
    console.warn("Failed to play notification sound:", error);
  }
}

/**
 * Check if the document is currently visible (for determining when to show notifications)
 */
export function isDocumentVisible(): boolean {
  return !document.hidden;
}
